import { first } from 'lodash'
import hooks from '../../../hooks'
import useSurveys from './use-facilitator-surveys'

const useIncompleteUserSurvey = () => {
    const { isActive, snooze } = hooks.useSnooze({ durationMinutes: 120 })
    const { isStudent } = hooks.useCurrentUser()

    const { facilitatorSurveys, isLoadingFacilitatorSurveys } = useSurveys()
    const hasSurveys = isStudent && !isLoadingFacilitatorSurveys && isActive && facilitatorSurveys.length
    const facilitatorSurvey = first(facilitatorSurveys)

    return {
        facilitatorSurvey,
        hasSurveys,
        dismiss: snooze
    }
}

export default useIncompleteUserSurvey
